export const enum FormStatus {
  IDLE = 'idle',
  SSR = 'ssr',
  PROCESSING_BOOK_REQUEST = 'processing-book-request',
  PROCESSING_USER_DETAILS = 'processing-user-details',
  PROCESSING_PAYMENT_DETAILS = 'processing-payment-details',
  INITIALIZING = 'initializing',
  PROCESSING_COUPON = 'processing-coupon',
}
